module.exports = __webpack_public_path__ + "img/works_kuraray_miniapp_4@3x.ac252fad.png";